import { useAxios } from "../../../../hooks/useAxios"
import { EmpresasAdapters } from "../adapters/empresas.adapters"
import { useIntegraWeb } from "./noticias.services"

const EmpresasServices = {

    GET_DISPONIBLES: function () {

        return useAxios({
            method: 'get',
            url: '/integra-web/empresas/autorizaciones/disponibles',
            type: 'json',
            adapters: EmpresasAdapters.GET_DISPONIBLES
        })
    },

    GET_BUSCAR_EMPRESA: function () {

        return useAxios({
            method: 'get',
            url: '/integra-web/empresas/autorizaciones/buscar-empresa',
            type: 'json',
            adapters: EmpresasAdapters.GET_BUSCAR_EMPRESA
        })
    },

    // GET /integra-web/empresas/mi-acceso
    // Acceso del usuario de la sesión al módulo de empresas. Lo consulta `AppRouter` al
    // arrancar para decidir si el menú muestra el enlace de Empresas.
    GET_MI_ACCESO: function () {

        return useAxios({
            method: 'get',
            url: '/integra-web/empresas/mi-acceso',
            type: 'json',
            adapters: EmpresasAdapters.GET_MI_ACCESO
        })
    },

    // GET /integra-web/empresas/consultar/{id}
    // Detalle de una empresa (NIF/CIF incluido) para el panel backoffice.
    GET_EMPRESA: function () {

        return useAxios({
            method: 'get',
            url: '/integra-web/empresas/consultar',
            type: 'json',
            adapters: EmpresasAdapters.GET_EMPRESA
        })
    },

    POST_SOLICITAR: function () {

        return useAxios({
            method: 'post',
            url: '/integra-web/empresas/autorizaciones/solicitar',
            type: 'json',
            adapters: EmpresasAdapters.POST_SOLICITAR
        })
    },

    // POST /integra-web/empresas/registrar
    // Alta de empresa desde el modal "Buscar y autorizar empresa", para el caso en que
    // no exista en el catálogo. La deja creada y con la solicitud de acceso del usuario
    // de la sesión pendiente de que la empresa la acepte.
    POST_REGISTRAR_EMPRESA: function () {

        return useAxios({
            method: 'post',
            url: '/integra-web/empresas/registrar',
            type: 'json',
            adapters: EmpresasAdapters.POST_REGISTRAR_EMPRESA
        })
    },

    // PATCH /integra-web/empresas/datos/{id}
    // Guarda los datos de la empresa editables desde el backoffice. El `id` se
    // concatena al final de la url por el propio hook (`url + '/' + values.id`).
    UPDATE_DATOS_EMPRESA: function () {

        return useAxios({
            method: 'patch',
            url: '/integra-web/empresas/datos',
            type: 'json',
            adapters: EmpresasAdapters.UPDATE_DATOS_EMPRESA
        })
    },

    // POST {REACT_APP_WEB_SERVICE_ACTIVIDADES}/integraWeb.php  accion=comprobar-empresa
    // Única excepción dentro del servicio: es una acción del WS d'Activitats y no
    // un endpoint de la API REST del backoffice, así que se llama con el fetcher
    // `useIntegraWeb` (parámetros y token en el formato que espera ese WS).
    COMPROBAR_EMPRESA: function () {

        return useIntegraWeb(EmpresasAdapters.POST_COMPROBAR_EMPRESA, { method: 'post' })
    },
}

export {
    EmpresasServices
}